<template>
    <NuxtLayout>
        <div class="documents">
            <Breadcrumb page="Документы"/>
            <h1 class="title">Документы</h1>
            <div class="politics">
                <h2 class="politics-title">Политики</h2>
                <div class="politics-links">
                    <FileLink v-for="doc in politics" :key="doc.id" :fileUrl="doc.link" :fileName="doc.title"/>
                </div>
            </div>
            <div class="documents-block">
                <h2 class="documents-title">Договоры</h2>
                <div class="documents-links">
                    <FileLink v-for="doc in contracts" :key="doc.id" :fileUrl="doc.link" :fileName="doc.title" :icon-src="doc.iconSrc" :format="doc.format"/>
                </div>
            </div>
            <div class="documents-block">
                <h2 class="documents-title">Заявления</h2>
                <div class="documents-links">
                    <FileLink v-for="doc in statements" :key="doc.id" :fileUrl="doc.link" :fileName="doc.title" :icon-src="doc.iconSrc" :format="doc.format"/>
                </div>
            </div>
            <div class="documents-block">
                <h2 class="documents-title">Письма о грузе</h2>
                <div class="documents-links">
                   <FileLink v-for="doc in letters" :key="doc.id" :fileUrl="doc.link" :fileName="doc.title" :icon-src="doc.iconSrc" :format="doc.format"/>
                </div>
            </div>
            <div class="documents-block">
                <h2 class="documents-title">Доверенности</h2>
                <div class="documents-links">
                    <FileLink v-for="doc in attorney" :key="doc.id" :fileUrl="doc.link" :fileName="doc.title" :icon-src="doc.iconSrc" :format="doc.format"/>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup >
import FileLink from '~/components/Input/FileLink.vue';
import Breadcrumb from '~/components/Input/Breadcrumb.vue';

useHead({
    title: 'Документы для перевозки Беларусь – Россия | ПЭК',
    meta: [
        { name: 'description', content: 'Набор необходимых документов для грузоперевозки по направлению из Беларуси в Россию и из России в Беларусь транспортной компанией ПЭК. Помощь в оформлении транспортных документов.' }
    ]
})

const politics =  [
    {
        id: 1,
        title: 'Политика обработки персональных данных ООО «ПЭК Бел»',
        link: '/upload/Политика обработки персональных данных..docx',
    },
    {
        id: 2,
        title: 'Согласие на обработку персональных данных Пользователя',
        link: '/upload/Согласие на обработку ПД (пользователь сайта)..docx',
    },
    {
        id: 3,
        title: 'Согласие на получение информационных сообщений рекламного характера',
        link: '/upload/Согласие на получение рекламной рассылки..docx',
    },
    {
        id: 4,
        title: 'Политика обработки cookie - файлов',
        link: '/upload/Политика обработки файлов Cookie..docx',
    },
];

const contracts =  [
    {
        id: 1,
        title: 'Договор транспортно-экспедиционного обслуживания (Публичная оферта для резидентов Беларуси)',
        link: '/upload/ДОГОВОР ПЭК Бел Клиентский.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 2,
        title: 'Договор транспортной экспедиции FTL ПЭК Беларусь',
        link: '/upload/ДОГОВОР ПЭК Бел ФТЛ.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
];

const statements =  [
    {
        id: 1,
        title: 'Заявление о приостановке',
        link: '/upload/Заявление о приостановке.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 2,
        title: 'Заявление об изменении грузополучателя',
        link: '/upload/Заявление об изменении грузополучателя.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 3,
        title: 'Заявление о возврате излишне уплаченных денежных средствах',
        link: '/upload/Заявление _о_возврате_излишне_уплаченных_денежных_средств.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 4,
        title: 'Заявление о верном назначении платежа',
        link: '/upload/Заявление_о_верном_назначении_платежа.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 5,
        title: 'Заявление об изменении плательщика',
        link: '/upload/Заявление_об_изменении_плательщика.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
];

const letters  =  [
    {
        id: 1,
        title: 'Сопроводительное письмо для физических лиц',
        link: '/upload/сопроводительное письмо ПЭК Бел для физ лиц.docx',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 2,
        title: 'CMR Бланк',
        link: '/upload/CMR.doc',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 3,
        title: 'CMR Пример заполнения',
        link: '/upload/cmr.png',
        iconSrc: '/images/documents/icon-image.svg',
        format: 'png'
    },
];

const attorney =  [
    {
        id: 1,
        title: 'Доверенность на получение грузов на территории Республики Беларусь (для физических лиц)',
        link: '/upload/Доверенность_на_получение_груза_ФЛ_бланк.doc',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 2,
        title: 'Доверенность на получение грузов на территории Республики Беларусь (для ЮЛ и ИП)',
        link: '/upload/Доверенность_на_получение_груза_ЮЛ_бланк.doc',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
    {
        id: 3,
        title: 'Доверенность на отправку груза (для юридических лиц, резидентов Республики Беларусь)',
        link: '/upload/Доверенность_на_отправку_груза_от_имени_юрлица.doc',
        iconSrc: '/images/documents/icon-document.svg',
        format: 'doc'
    },
];
</script>

<style>
.documents {
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: 100%;
    max-width: 1280px;
    margin: 40px auto 80px;

    @media screen and (max-width: 1300px) {
        &:not(.no-padding) {
            max-width: unset;
            margin: 0;
            padding: 0 16px;
            margin-top: 20px;
        }
    }
}

.title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 48px;
    leading-trim: NONE;
    line-height: 60px;
    letter-spacing: 0%;
    margin: 0;
}

.politics {
    display: flex;
    flex-direction: column;
    gap: 36px;
}

.politics-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 32px;
    letter-spacing: 0%;
    margin: 0;
}

.politics-links {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.politics-link {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #48538B;
    margin: 0;
}

.documents-block {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.documents-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 32px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}

.documents-links {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

</style>
